import React from "react";
import {
  AccountsSort,
  PortfolioAccountData,
} from "@shared/features/portfolio/types";
import { SortingOrder } from "@shared/types";

export const AccountsPageContext = React.createContext<
  | {
      accounts: PortfolioAccountData[];
      sortBy: AccountsSort;
      sortDirection: SortingOrder;
      setSortBy: (sortBy: AccountsSort) => void;
      setSortDirection: (sortDirection: SortingOrder) => void;
      isLoading: boolean;
      isFetching: boolean;
      refetch: () => void;
      isLoadingPortfolioData: boolean;
      isCardsView: boolean;
      setIsCardsView: (isCardsView: boolean) => void;
    }
  | undefined
>(undefined);
